/* unplugin-vue-components disabled */import script from "./CopyButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CopyButton.vue?vue&type=script&lang=ts&setup=true"

import "./CopyButton.vue?vue&type=style&index=0&id=75f4bc17&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75f4bc17"]])

export default __exports__